// eslint-disable-next-line import/no-unresolved
import { useUserV2 } from "hooks";

export const useNMCustomerJourney = (): boolean => {
  const { isMember, hasMembershipInBag } = useUserV2();
  const isNMCustomerJourney = !isMember && !hasMembershipInBag;

  return isNMCustomerJourney;
};
